import styled from 'styled-components';

interface ISelectProps {
    hasError: boolean;
}

export const SelectContainer = styled.div<ISelectProps>`
    display: flex;
    flex-flow: column;
    position: relative;
    width: 100%;

    select {
        padding: 0.25rem 0.75rem;
        height: 2.25rem;
        color: ${({ theme }) => theme.colors.formLabel};
        font-size: ${({ theme }) => theme.fontSizes[3]};
        border-radius: 0.375rem;
        border: ${({ hasError, theme }) =>
            hasError
                ? `2px solid ${theme.colors.formError}`
                : `1px solid ${theme.colors.formInput}`};
    }
`;

export const StyledLabel = styled.label`
    margin-bottom: 0.25rem;
    color: ${({ theme }) => theme.colors.fontPrimary};
    font-size: ${({ theme }) => theme.fontSizes[4]};
`;

export const StyledError = styled.span`
    position: absolute;
    height: 2rem;
    bottom: -2.25rem;
    min-height: 0.875rem;
    margin-top: 0.375rem;
    color: ${({ theme }) => theme.colors.formError};
    font-size: ${({ theme }) => theme.fontSizes[3]};
`;
